export const CART_COOKIE = 'cartId';
export const COUNTRY_COOKIE = 'countryCode';
export const META_SHOP_COOKIE = 'metaShopParams';
export const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
export const STATSIG_COOKIE = 'statsigStableId';
